var map = {
	"./full-screen-icon.svg": "673e",
	"./left-nav.svg": "9daa",
	"./leftbutton-fill.svg": "bc52",
	"./light-nav.svg": "ec20",
	"./tobacco.svg": "0468",
	"./top-nav.svg": "e1e4",
	"./welcome.svg": "8121"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";